import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'

import { EMPTY, Observable, catchError, of, tap } from 'rxjs'
import { SpinnerService } from '@shared/services'

/** Pass untouched request through to the next request handler. */
@Injectable({
  providedIn: 'root',
})
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private _spinnerService: SpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._spinnerService.showSpinner()

    return next.handle(req).pipe(
      tap((i) => {
        if (i.type) {
          this._spinnerService.hideSpinner()
        }
      }),
    )
  }
}
